import { render, staticRenderFns } from "./DepartmentsMultiSelect.vue?vue&type=template&id=3cc7491c&"
import script from "./DepartmentsMultiSelect.vue?vue&type=script&lang=js&"
export * from "./DepartmentsMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports